import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { checkPasswordAuthGuard } from './core/guards/checkPasswordAuth/check-password-auth.guard';
import { authGuardToCheckUserLoggedInStatus } from './core/guards/auth.guard';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { PaymentPendingComponent } from './pages/paymentScreen/payment-pending/payment-pending.component';
import { PaymentCancelComponent } from './pages/paymentScreen/payment-cancel/payment-cancel.component';
import { PaymentSuccessComponent } from './pages/paymentScreen/payment-success/payment-success.component';
import { TermsandconditionComponent } from './pages/termsandcondition/termsandcondition.component';
import { HomeComponent } from './features/user-artist/components/home/home.component';
import { ProfileFullDetailsComponent } from './shared/components/artist-profile-card/profile-full-details/profile-full-details.component';
import { checkRoleGuard } from './features/user-artist/userArtistGuard/checkUserRole/check-role.guard';
import { UserSelectArtsComponent } from './shared/components/user-select-arts/user-select-arts.component';
import { BuyFramesComponent } from './features/user-artist/components/audience/buy-frame/buy-frame.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';

export const routes: Routes = [
  { path: '', pathMatch: "full", redirectTo: "gallery" },

  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms-and-conditions', component: TermsandconditionComponent },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
    data: { preload: true },
    canActivate: [authGuardToCheckUserLoggedInStatus],
  },
  {
    path: 'gallery',
    loadChildren: () =>
      import('./features/user-artist/user-artist.module').then(
        (m) => m.UserArtistModule
      ),
    data:{ preload:true },
  },
 {
    path: 'artist',
    component: HomeComponent,
    children: [
      {
        path: ':id',
        component: ProfileFullDetailsComponent,
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
      {
        path: ':albumName/:albumId',
        component: UserSelectArtsComponent,
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
    ]
  },
  {
    path: 'buyframes/:userId',
    component: HomeComponent,
    children: [
      {
        path: ':userId',
        component: BuyFramesComponent,
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
    ]
  },
  { path: 'payment_success', component: PaymentSuccessComponent },
  { path: 'payment_cancel', component: PaymentCancelComponent },
  { path: 'payment_pending', component: PaymentPendingComponent },
 { path: 'auth/callback', component: AuthCallbackComponent },
  // Wildcard route for a 404 page
  { path: '**', component: PageNotFoundComponent },
];
